import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environment/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FeeScheduleService {
  baseUrl = `${environment.apiBase}/clinics`
  http = inject(HttpClient)

  // will potentially need an endpoint to fetch all fee schedules per clinic in multiple providers 
  get = (clinic_id: number, provider_id: number) =>
    this.http.get(`${this.baseUrl}/${this.setUrl(clinic_id, provider_id)}`)  

    create = (  clinic_id: number,  provider_id: number,  body: Record<string, unknown>) =>
    this.http.post(`${this.baseUrl}/${this.setUrl(clinic_id, provider_id)}`, body)

  delete = (clinic_id: number, provider_id: number) => 
    this.http.delete(`${this.baseUrl}/${this.setUrl(clinic_id, provider_id)}`)

  createBulk = (
                  clinic_id: number,
                  provider_ids: number[],
                  body: Record<string, unknown>
                ) =>
    this.http.post(`${this.baseUrl}/${clinic_id}/providers/${provider_ids.join(',')}/fee-schedule`, body)

  private setUrl = (clinic_id: number, provider_id: number) => 
    `${clinic_id}/providers/${provider_id}/fee-schedule`

  getFeeScheduleUrl = (clinic_id: number, provider_id: number) => 
    this.http.get(`${this.baseUrl}/${clinic_id}/providers/${provider_id}/fee-schedule/download`)
}
